import { useState } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '../assets/icons/close.svg?react';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { useLayoutTier } from '../hooks/useLayoutTier';
import { AccountButton } from './AccountButton';
import { IconButton } from './IconButton';
import { Navigation } from './Navigation';
import { PRODUCT_LOGO } from '../demo/demoMode';

export function SidebarMobile() {
  const { isOpen, close, toggle } = useMobileSidebar();
  const { isTabletDown } = useLayoutTier();
  const [shouldRender, setShouldRender] = useState(false);

  if (!isTabletDown) {
    return null;
  }

  // Keep component mounted if opening or if we need to animate out
  const show = isOpen || shouldRender;

  const handleAnimationEnd = () => {
    if (!isOpen) {
      setShouldRender(false);
    }
  };

  // Show immediately when opening
  if (isOpen && !shouldRender) {
    setShouldRender(true);
  }

  if (!show) return null;

  const state = isOpen ? 'open' : 'closed';

  return createPortal(
    <>
      {/* Overlay */}
      <div
        data-mobile-sidebar-overlay
        data-state={state}
        className='fixed inset-0 z-40 bg-black/50'
        onClick={close}
        onAnimationEnd={handleAnimationEnd}
      />

      {/* Sidebar */}
      <aside
        data-mobile-sidebar
        data-state={state}
        className='bg-surface border-border-primary fixed top-0 left-0 z-50 flex
          h-full w-70 flex-col justify-between border-r shadow-xl md:w-80'
      >
        <div
          className='border-border-primary flex shrink-0 items-center
            justify-between border-b px-4 pt-10 pb-4'
        >
          <div className='flex items-end gap-2'>
            <img
              src='/tomra-logo-text.svg'
              alt='Tomra Logo'
              className='h-3.5'
            />
            <img
              src={PRODUCT_LOGO.src}
              alt={PRODUCT_LOGO.alt}
              className='h-2.5'
            />
          </div>
          <IconButton
            aria-label='Toggle menu'
            icon={<CloseIcon height={20} width={20} />}
            onClick={toggle}
            className='text-focus'
          />
        </div>
        <div className='flex flex-1 flex-col justify-between'>
          <Navigation />
          <AccountButton
            className='mx-3 mt-3 mb-4 max-w-full gap-4 p-2'
            avatarClassName='h-10 w-10'
          />
        </div>
      </aside>
    </>,
    document.body
  );
}
